import { Globe, NotebookPen, Telescope } from "lucide-react";
import type { LucideIcon } from "lucide-react";

/**
 * Three claims, not three features: how far the timeline reaches, that you need
 * not use it at all, and who else gets to read any of it. How collections
 * actually behave is something the app teaches better than a landing page can.
 */
const POINTS: { icon: LucideIcon; label: string; body: string }[] = [
  {
    icon: Telescope,
    label: "One scale, all of time",
    body: "Zoom from eras down to seconds. The fall of Rome and yesterday afternoon sit on the same axis.",
  },
  {
    icon: NotebookPen,
    label: "A notebook too",
    body: "Nothing has to carry a date. Keep plain notes and journal entries in collections and use it as an everyday notebook.",
  },
  {
    icon: Globe,
    label: "Yours, or shared",
    body: "A space is private by default. Make a collection public and anyone can read it; people who like it can follow along.",
  },
];

export default function ValueStrip() {
  return (
    <section className="grid gap-8 border-t pt-10 sm:grid-cols-3">
      {POINTS.map(({ icon: Icon, label, body }) => (
        <div key={label}>
          <Icon className="size-5 text-muted-foreground" strokeWidth={1.5} />
          <h2 className="mt-3 text-[10.5px] font-bold uppercase tracking-[.1em] text-muted-foreground">
            {label}
          </h2>
          <p className="mt-2 text-[13.5px] leading-[1.6] text-ink2">{body}</p>
        </div>
      ))}
    </section>
  );
}
